/**
 * Effects registry: maps an {@link EffectId} to the component that renders it.
 * Adding an ambient effect is one component plus one entry here.
 */
import React from 'react';

import { BatsOverlay } from './BatsOverlay';
import { FireworksOverlay } from './FireworksOverlay';
import { LeavesOverlay } from './LeavesOverlay';
import { PetalsOverlay } from './PetalsOverlay';
import { ShamrocksOverlay } from './ShamrocksOverlay';
import { SnowOverlay } from './SnowOverlay';

import type { EffectId } from '../decorations';


/** Ambient effect components keyed by id. */
export const EFFECT_COMPONENTS: Record<EffectId, React.FC> = {
  snow: SnowOverlay,
  bats: BatsOverlay,
  petals: PetalsOverlay,
  leaves: LeavesOverlay,
  fireworks: FireworksOverlay,
  shamrocks: ShamrocksOverlay,
};
